import { Request } from '../utils';

const prefix = 'dashboard';

export const getDashboardDetail = queries => {
  const { min_filter_date, max_filter_date } = queries;
  const params = new URLSearchParams();

  !!min_filter_date && params.append('min_filter_date', min_filter_date);
  !!max_filter_date && params.append('max_filter_date', max_filter_date);

  return Request.get(`${prefix}`, { params, onlyError: true });
};
